module.exports = __webpack_public_path__ + "static/images/opportunities-stroke.6bc1b44e6009bcf91af746e952536cd4.svg";